import { actions as messages } from './messages'
import { actions as misc } from './misc'
import { actions as reports } from './reports'
import { actions as participants } from './participants'
import { actions as profiles } from './profiles'
import { actions as settings } from './settings'
import { actions as users } from './users'
import { actions as sessions } from './sessions'

const actions = {
    ...messages,
    ...misc,
    ...reports,
    ...participants,
    ...profiles,
    ...settings,
    ...users,
    ...sessions
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions/index.js